import type {
    AccessorKeyColumnDef,
    ColumnDef,
    GroupColumnDef,
} from '@tanstack/react-table'

const getAllLeafColumnIdsFromColumn = <T>(
    ids: string[],
    column: ColumnDef<T>
): void => {
    const group = column as GroupColumnDef<T>

    if (Array.isArray(group.columns)) {
        for (const child of group.columns) {
            getAllLeafColumnIdsFromColumn(ids, child)
        }
        return
    }

    const accessorKey = (column as AccessorKeyColumnDef<unknown>).accessorKey
    const id =
        column.id ?? (typeof accessorKey === 'string' ? accessorKey : undefined)

    if (id) ids.push(id)
}

export const extractColumnIds = <T>(columns: ColumnDef<T>[]): string[] => {
    const ids: string[] = []

    for (const column of columns) {
        getAllLeafColumnIdsFromColumn(ids, column)
    }

    return ids
}
